export var DownloaderWebrtcAction;
(function (DownloaderWebrtcAction) {
    DownloaderWebrtcAction["Download"] = "downloader.download";
    DownloaderWebrtcAction["Complete"] = "downloader.complete";
    DownloaderWebrtcAction["Abort"] = "downloader.abort";
    DownloaderWebrtcAction["List"] = "downloader.list";
    DownloaderWebrtcAction["RecordDaily"] = "record.daily";
})(DownloaderWebrtcAction || (DownloaderWebrtcAction = {}));
